import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "./Forms/Form";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

/**
 *
 * @param {array} formContent - Contenu du formulaire
 * @param {object} schema - Schéma Yup
 * @param {function} submitFunction - Fonction à appeler lors de la soumission du formulaire
 * @param {function} deleteFunction - Fonction à appeler lors du clic sur le bouton "Supprimer"
 * @param {function} setHoldingSelected - Définit le holding sélectionné depuis le formulaire
 * @param {function} updateSla - Mets à jour le SLA lors du clic sur le bouton "Recalculer SLA"
 * @param {function} updateEquipment - Mets à jour les équipements lors du clic sur le bouton "Mettre à jour"
 * @param {function} stateQueryRow - Informations sur les données, exemple : (state: bool, name: string, source: string, type: string)
 * @returns
 */

export default function Update({
  formContent,
  schema,
  submitFunction,
  deleteFunction,
  setHoldingSelected,
  updateSla,
  updateEquipment,
  stateQueryRow
}) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  return (
    <div className="table-update">
      {user.roles.includes("ROLE_SUPERADMIN") && updateEquipment && (
        <button className="buttons-ecp buttons-ecp-upgrade" onClick={updateEquipment}>
          {t("Mettre à jour")}
        </button>
      )}
      {user.roles.includes("ROLE_SUPERADMIN") && updateSla && (
        <button className="buttons-ecp buttons-ecp-upgrade" onClick={updateSla}>
          {t("Recalculer SLA")}
        </button>
      )}
      {user.roles.includes('ROLE_SUPERADMIN') && (
        <Form
          formContent={formContent}
          schema={schema}
          submitFunction={submitFunction}
          title="Modifier"
          action="update"
          setHoldingSelected={setHoldingSelected}
          stateQueryRow={stateQueryRow}
        />
      )}
      {user.roles.includes("ROLE_SUPERADMIN") && (
        <button className="buttons-ecp buttons-ecp-delete" onClick={deleteFunction}>
          {" "}
          <FontAwesomeIcon icon={faTrash} /> {t("Supprimer")}{" "}
        </button>
      )}
    </div>
  );
}
